

import { HTMLAttributes, ReactElement } from "react";

interface Props extends HTMLAttributes<HTMLElement> {
    color?: string;
}
    
     function Wiki({ color }: Props): ReactElement {

    return (
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M1.66797 10.0007C1.66797 6.85795 1.66797 5.28661 2.64428 4.3103C3.62059 3.33398 5.19194 3.33398 8.33464 3.33398H11.668C14.8107 3.33398 16.382 3.33398 17.3583 4.3103C18.3346 5.28661 18.3346 6.85795 18.3346 10.0007C18.3346 13.1433 18.3346 14.7147 17.3583 15.691C16.382 16.6673 14.8107 16.6673 11.668 16.6673H8.33463C5.19194 16.6673 3.62059 16.6673 2.64428 15.691C1.66797 14.7147 1.66797 13.1433 1.66797 10.0007Z" stroke="#424242"/>
<path d="M8.33333 13.334H5" stroke="#155a9e" strokeLinecap="round"/>
<path d="M11.6667 10.834H15" stroke="#155a9e" strokeLinecap="round"/>
<path d="M11.668 13.334H10.418" stroke="#155a9e" strokeLinecap="round"/>
<path d="M7.91536 10.834H9.58203" stroke="#155a9e" strokeLinecap="round"/>
<path d="M15 13.334H13.75" stroke="#155a9e" strokeLinecap="round"/>
<path d="M4.9987 10.834H5.83203" stroke="#155a9e" strokeLinecap="round"/>
</svg>
    );
}

export default Wiki;